import {Col, Form, Row} from 'react-bootstrap'
import Select from 'react-select'
import {FormattedMessage, defineMessages, useIntl} from 'react-intl'
import {COUNTRIES, MARITAL_STATUS} from '../../../../../helpers/consts'
import {TFormMemberPolicy} from '../../../../policies/policiesTypes'

const maritalStatusMsg = defineMessages({
  Married: {id: 'policies.detail.form.member.marital.married', defaultMessage: 'Married'},
  'Head of Household': {
    id: 'policies.detail.form.member.marital.headOfHousehold',
    defaultMessage: 'Head of Household',
  },
  Single: {id: 'policies.detail.form.member.marital.single', defaultMessage: 'Single'},
  Other: {id: 'common.option.other', defaultMessage: 'Other'},
})

interface SpecificInformationMemberProps {
  membernum: number
  values: TFormMemberPolicy
  handleChange: (field: string, value: string) => void
}

export const SpecificInformationMember: React.FC<SpecificInformationMemberProps> = ({
  membernum,
  values,
  handleChange,
}) => {
  const intl = useIntl()
  // console.log('SpecificInformationMember:' + JSON.stringify(values))
  return (
    <Row>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`maritalStatus_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.maritalStatus'
              defaultMessage='Marital status'
            />
          </Form.Label>
          <Form.Select
            name={`maritalStatus_${membernum}`}
            id={`maritalStatus_${membernum}`}
            value={values.maritalStatus ?? ''}
            onChange={(e) => handleChange('maritalStatus', e.target.value)}
            aria-label={intl.formatMessage({
              id: 'policies.detail.form.member.maritalStatus',
              defaultMessage: 'Marital status',
            })}
          >
            <option value=''>
              {intl.formatMessage({id: 'common.placeholder.selectOption', defaultMessage: 'Select an option'})}
            </option>
            {MARITAL_STATUS.map((mari) => (
              <option key={mari} value={mari}>
                {maritalStatusMsg[mari as keyof typeof maritalStatusMsg]
                  ? intl.formatMessage(maritalStatusMsg[mari as keyof typeof maritalStatusMsg])
                  : mari}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`countryBirth_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.countryBirth'
              defaultMessage='Country of birth'
            />
          </Form.Label>
          <Select
            inputId={`countryBirth_${membernum}`}
            value={COUNTRIES.find((opt) => opt.value === values.countryBirth) || null}
            onChange={(option) => {
              const value = option ? option.value : ''
              handleChange('countryBirth', value)
            }}
            options={COUNTRIES}
            styles={{control: (base) => ({...base, padding: '3px 0'})}}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`weight_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.weight'
              defaultMessage='Weight (kg)'
            />
          </Form.Label>
          <Form.Control
            type='number'
            value={values.weight ?? ''}
            name={`weight_${membernum}`}
            id={`weight_${membernum}`}
            placeholder={intl.formatMessage({id: 'policies.detail.form.member.enterWeight', defaultMessage: 'Enter weight'})}
            onChange={(e) => {
              handleChange('weight', e.target.value)
            }}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`height_${membernum}`}>
            <FormattedMessage
              id='policies.detail.form.member.height'
              defaultMessage='Height (cm)'
            />
          </Form.Label>
          <Form.Control
            type='number'
            value={values.height ?? ''}
            name={`height_${membernum}`}
            id={`height_${membernum}`}
            placeholder={intl.formatMessage({id: 'policies.detail.form.member.enterHeight', defaultMessage: 'Enter height'})}
            onChange={(e) => {
              handleChange('height', e.target.value)
            }}
          />
        </Form.Group>
      </Col>
    </Row>
  )
}
